module.exports = __webpack_public_path__ + "img/dou.0cc24076.png";